import apiClient from './client';
import type {
  EducationInquiry,
  InquiryFilters,
  InquiryPatchPayload,
  InquiryStats,
  PaginatedInquiries,
} from '../types/educationInquiry';

const BASE = '/admin/education-inquiries';

export async function listInquiries(filters: InquiryFilters = {}): Promise<PaginatedInquiries> {
  const params: Record<string, string | number> = {};
  if (filters.status) params.status = filters.status;
  if (filters.assigned_to !== undefined && filters.assigned_to !== null) {
    params.assigned_to = filters.assigned_to;
  }
  if (filters.search) params.search = filters.search;
  if (filters.created_after) params.created_after = filters.created_after;
  if (filters.created_before) params.created_before = filters.created_before;
  if (filters.intended_use) params.intended_use = filters.intended_use;
  if (filters.timeline) params.timeline = filters.timeline;
  if (filters.email_sent !== undefined) params.email_sent = String(filters.email_sent);
  if (filters.ordering) params.ordering = filters.ordering;
  if (filters.limit !== undefined) params.limit = filters.limit;
  if (filters.offset !== undefined) params.offset = filters.offset;

  const { data } = await apiClient.get<PaginatedInquiries>(`${BASE}/`, { params });
  return data;
}

export async function getInquiry(inquiryId: string): Promise<EducationInquiry> {
  const { data } = await apiClient.get<EducationInquiry>(`${BASE}/${inquiryId}/`);
  return data;
}

export async function patchInquiry(
  inquiryId: string,
  payload: InquiryPatchPayload,
): Promise<EducationInquiry> {
  const { data } = await apiClient.patch<EducationInquiry>(`${BASE}/${inquiryId}/`, payload);
  return data;
}

export async function getInquiryStats(days = 90): Promise<InquiryStats> {
  const { data } = await apiClient.get<InquiryStats>(`${BASE}/stats/`, { params: { days } });
  return data;
}
